module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAYBAMAAADewBogAAAAElBMVEUAAAAj0KUj0KUj0KUj0KUj0KU7VCtpAAAABXRSTlMA+U07rKKVQfQAAABHSURBVAjXYwADAzDJJACmFAPAHFEwpRgaAOYAKRAHSAE5QArEAVJADpgyDAVTrjAKKghTAtOA0A7iIowGc2HWwh2BcBKDAQBgRRa5sB9pJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon_triangle.png
// module id = gRGg
// module chunks = 1